<template>
  <div class="contact-group-row">
    <div class="contact-group__title">
      <span>{{ item.name }}</span>
    </div>

    <div class="contact-group__user">
      <img src="/img/icons/pbx/group-user.svg" alt="" />
      <span>{{ item.contact_methods_count }}</span>
    </div>

    <div class="contact-group__worksheet">
      <work-time-list :items="worktimes" />
    </div>

    <div v-if="$slots['controls']" class="contact-group__controls">
      <slot name="controls"></slot>
    </div>
  </div>
</template>

<script>
  import WorkTimeList from '@pbx/components/time-conditions/_fragments/worktime/list-collapse';

  export default {
    components: {
      WorkTimeList
    },
    props: {
      item: {
        type: Object,
        default: () => ({})
      }
    },

    computed: {
      worktimes: function() {
        try {
          return this.item.time_condition.worktimes;
        } catch (e) {
          return [];
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .contact-group-row {
    padding: 10px 0;
    border-bottom: 1px solid #f5f6f8;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;

    &:nth-last-child(1) {
      border-bottom: none;
    }
  }

  .contact-group {
    &__title {
      width: 100px;
      flex: none;
    }

    &__user {
      width: 65px;
      display: flex;
      align-items: center;

      img {
        margin-top: -1px;
        width: 13px;
        display: inline-block;
        margin-right: 3px;
      }
    }

    &__worksheet {
      width: 210px;
      display: flex;
      flex-direction: column;
    }

    .contact-group__title,
    .contact-group__user,
    .contact-group__controls {
      display: flex;
      align-items: center;
      height: 36px;
    }
  }
</style>
